import React from 'react';

const ContactForm = () => {
  return (
    <form
      name="contact-us"
      method="post"
      data-netlify="true"
      data-netlify-honeypot="bot-field"
      className="form-group"
    >
      <input type="hidden" name="form-name" value="contact-us" />
      <input
        name="name"
        type="text"
        required
        className="form-control form-control-lg site-form my-2"
        placeholder="Name"
      />
      <input
        name="email"
        type="email"
        required
        className="form-control form-control-lg site-form my-2"
        placeholder="Email"
      />
      <textarea
        id="message"
        required
        name="message"
        placeholder="Message"
        className="form-control form-control-lg site-form my-2"
        rows="3"
      />
      <button className="text-white btn btn-primary btn-xl" type="submit">
        Send
      </button>
    </form>
  );
};

export default ContactForm;
